import React, { useEffect, useState } from 'react';
import { Modal, ModalHeader, ModalBody, Button, Table, Col, Row, Label } from 'reactstrap';
import BootstrapTable from "react-bootstrap-table-next";
import "../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import ToolkitProvider, {
    Search,
} from "react-bootstrap-table2-toolkit";
import "../../../../node_modules/react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import { withNamespaces } from 'react-i18next';
import { formatUnitsForReport } from '../../../helpers/units';
import moment from 'moment';

const DeficitOrderDetails = ({
    isOpen,
    toggle,
    details,
    t,
}) => {

    const columns = [
        {
            dataField: "_id",
            hidden: true,
        },
        {
            dataField: "order_to",
            text: t("Order To"),
            headerStyle: (colum, colIndex) => {
                return { width: "10%" };
            },
        },
        {
            dataField: "category",
            text: t("Category"),
            headerStyle: (colum, colIndex) => {
                return { width: "12%" };
            },
        },
        {
            dataField: "sub_category",
            text: t("Sub-Category"),
            headerStyle: (colum, colIndex) => {
                return { width: "12%" };
            },
        },
        {
            dataField: "name",
            text: t("Name"),
            headerStyle: (colum, colIndex) => {
                return { width: "15%" };
            },
            sort: true,
        },
        {
            text: t("From Supplier"),
            dataField: "direct_po",
            formatter: (cell, row) => {
                return row.direct_po ? "Yes" : "No"
            },
            sort: true,
            headerStyle: (colum, colIndex) => {
                return { width: "10%" };
            },
        },
        {
            dataField: "available",
            text: `${details?.branch_details?.type==="Branch" ? "Branch Avl. Qty.": "Store Avl. Qty."}`,
            formatter: (cell, row) => {
                return formatUnitsForReport(row.available,row.unit_levels)
            },
            sort: true,
            headerStyle: (colum, colIndex) => {
                return { width: "15%" };
            },
        },
        {
            dataField: "quantity",
            text: t("Order Quantity"),
            formatter: (cell, row) => {
                return formatUnitsForReport(row.quantity)
            },
            sort: true,
            headerStyle: (colum, colIndex) => {
                return { width: "15%" };
            },
        },
    ];

    const columns_received = [
        {
            dataField: "category",
            text: t("Category"),
            headerStyle: (colum, colIndex) => {
                return { width: "10%" };
            },
        },
        {
            dataField: "sub_category",
            text: t("Sub-Category"),
            headerStyle: (colum, colIndex) => {
                return { width: "10%" };
            },
        },
        {
            dataField: "name",
            text: t("Name"),
            headerStyle: (colum, colIndex) => {
                return { width: "15%" };
            },
            sort: true,
        },
        {
            text: t("From Supplier"),
            dataField: "direct_po",
            formatter: (cell, row) => {
                return row.direct_po ? "Yes" : "No"
            },
            sort: true,
            headerStyle: (colum, colIndex) => {
                return { width: "8%" };
            },
        },
        {
            dataField: "delivered_from",
            text: t("Dispatched From"),
            headerStyle: (colum, colIndex) => {
              return { width: "15%" };
            },
          },
        {
            text: t("Dispatch Time"),
            dataField: "date_of_transaction",
            formatter: (cell, row) => {
                return moment(row.date_of_transaction).format("DD/MM/YYYY HH:mm");
            },
            sort: true,
            headerStyle: (colum, colIndex) => {
                return { width: "15%" };
            },
        },
        {
            dataField: "original_delivered_quantity",
            text: t("Del. Qty."),
            formatter: (cell, row) => {
                return formatUnitsForReport(row.delivered_quantity,row.unit_levels)
            },
            sort: true,
            headerStyle: (colum, colIndex) => {
                return { width: "15%" };
            },
        },
        {
            dataField: "received_quantity",
            text: t("Rec. Qty."),
            formatter: (cell, row) => {
                return formatUnitsForReport(row.received_quantity,row.unit_levels)
            },

            sort: true,
            headerStyle: (colum, colIndex) => {
                return { width: "15%" };
            },
        },
        {
            text: t("Remarks"),
            dataField: "remarks",

            sort: true,
            headerStyle: (colum, colIndex) => {
                return { width: "10%" };
            },
        },
    ]; 
const [receivedItems, setReceivedItems] = useState([])
    useEffect(() => {
        if (!details || !details.delivery_details) {
            setReceivedItems([]);
            return;
        }

        const received_items = [];
        const to_receive_items = [];

        details.delivery_details.forEach((item) => {
            if (item.is_received) {
                received_items.push(item);
            } else {
                item.received_quantity = item.delivered_quantity;
                item.original_delivered_quantity = item.original_delivered_quantity;
                to_receive_items.push(item);
            }
        });
        setReceivedItems(received_items);
    }, [details]);
//  console.log(details,"de");
    return (
        <Modal isOpen={isOpen} toggle={toggle} onClosed={toggle} size="lg">
            <ModalHeader toggle={toggle}>
                Order Id : {details?.order_id}
            </ModalHeader>
            <ModalBody>
                <Row>
                    <Col lg={12} md={12}>
                        <Label>Ordered Items</Label>
                    </Col>

                    <Col lg={12}>
                        <BootstrapTable
                            bootstrap4
                            keyField="_id"
                            data={details && details.item_details}
                            columns={columns}
                            noDataIndication="No data to display."
                            striped
                            hover
                            condensed
                        />
                        <hr />
                    </Col>
                    {details && receivedItems && receivedItems.length > 0 ? (
                        <>
                            <Col lg={12} md={12}>
                                <br />
                                <Label>
                                    <b>{t("Received Items")} </b>
                                </Label>
                            </Col>
                            <Col lg={12} className="mb-4">
                                <BootstrapTable
                                    bootstrap4
                                    keyField="_id"
                                    key="_id"
                                    data={receivedItems}
                                    columns={columns_received}
                                    noDataIndication="No data to display."
                                    striped
                                    hover
                                    condensed
                                />
                                <hr />
                            </Col>
                        </>
                    ) : null}
                </Row>
            </ModalBody>
        </Modal>
    );
};

export default withNamespaces()(DeficitOrderDetails);